import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const NachaMarkAsFailedEvent = BaseLoanEvent.extend({
  type: z.literal('nachaMarkAsFailed'),
  paymentId: PaymentId,
  failureCode: z.string(),
});
export type NachaMarkAsFailedEvent = z.infer<typeof NachaMarkAsFailedEvent>;
